import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";
import { toast } from "sonner";

export default function AuthCallback() {
  const { google } = useAuth();
  const nav = useNavigate();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    google(sid)
      .then((u) => nav(u.onboarded ? "/" : "/onboarding", { replace: true }))
      .catch((e) => { toast.error(errMsg(e)); nav("/login", { replace: true }); });
  }, [google, nav]);
  return null;
}
